import { render, staticRenderFns } from "./basicsSet.vue?vue&type=template&id=04ef57fa&scoped=true&"
import script from "./basicsSet.vue?vue&type=script&lang=js&"
export * from "./basicsSet.vue?vue&type=script&lang=js&"
import style0 from "./basicsSet.vue?vue&type=style&index=0&id=04ef57fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef57fa",
  null
  
)

export default component.exports